import { mfOfflineHandling } from '@fe-toolkit/utility/modern/client'

// This runtime-bootstrap module must remain React-free. Dynamic imports ensure
// fallback components load only after a remote failure.
export default () =>
  mfOfflineHandling({
    timeoutMs: 3000,
    fallbacks: {
      'fe_common/components/CommonHeader': () =>
        import('@/components/fallbacks/FallbackHeader').then((module) => module.default),
      'fe_common/components/CommonFooter': () =>
        import('@/components/fallbacks/FallbackFooter').then((module) => module.default),
    },
  })
